import { FilterType } from './filter-type';

export interface FilterItem<T = any> {
  filter: T;
  active: boolean;
  type: FilterType;
}
